import Immutable from 'immutable';
import { ContentBlock, EditorState } from 'draft-js';
import { EditorProps } from 'react-draft-wysiwyg';
import { Section, Side, WordsAndSentencesContent } from '../../types';
import { LinesLimits } from '../../types/textEditor';
import { WORDS_WITH_SPECIAL_REGEX } from '../../constants';
import { BLOCK_TYPES } from '../../constants/textEditor';

export const getTextEditorProps = (isTitle = false, isRight = false): EditorProps => {
  const titleBlockRenderMap = Immutable.Map({
    [BLOCK_TYPES.headerTwo]: {
      element: 'h2',
    },
    [BLOCK_TYPES.unStyled]: {
      element: 'h2',
    },
  });

  const customStyleMap = {
    BOLD: {
      fontWeight: 800,
    },
  };

  return {
    wrapperClassName: 'text-editor-wrapper',
    toolbarClassName: `text-editor-toolbar ${isRight ? 'text-editor-toolbar-right' : ''}`,
    customStyleMap,
    ...(isTitle && { blockRenderMap: titleBlockRenderMap }),
  };
};

export const getEditorBlocksCount = (editorState: EditorState): number => {
  return editorState.getCurrentContent().getBlocksAsArray().length;
};

export const getCurrentBlock = (editorState: EditorState): ContentBlock => {
  const currentContent = editorState.getCurrentContent();
  const selectionState = editorState.getSelection();
  const anchorKey = selectionState.getAnchorKey();

  return currentContent.getBlockForKey(anchorKey);
};

export const getExemplarLinesLimits = (content: WordsAndSentencesContent['content'] | Side): LinesLimits => {
  return Object.entries(content).reduce((totalLimits, [sideName, sideContent]) => {
    return {
      ...totalLimits,
      ...sideContent.reduce((limits: LinesLimits, section: Section, index: number) => {
        if (section.type === 'section') {
          return {
            ...limits,
            [`${sideName}-${index}`]: section.lines.length,
          };
        }

        return limits;
      }, {}),
    };
  }, {});
};

export const parseWordsAndSymbols = (text = ''): string[] => {
  return text.match(WORDS_WITH_SPECIAL_REGEX) || [];
};
